<ng-container>
  @if (isTakingOver || !isFlagrDone) {
    <div class="spinner-container">
      <mat-spinner aria-label="Loading"></mat-spinner>
    </div>
  } @else {
    <div class="appform-header">
      <appform-header [activeMenuOrder]="activeQuestionSetOrder" (modeChange)="updateMenuOrder($event)"></appform-header>
    </div>
    @if (readOnly) {
      <div>
        <appform-quick-guide [readOnly]="readOnly" [formData]="formData"></appform-quick-guide>
      </div>
    }
    <div class="appform-container">
      <div class="container-navigation">
        <appform-question-set-navigation
          [activeMenuOrder]="activeQuestionSetOrder"
          [activeQuestionSet]="activeQuestionSet"
          (menuOrderChange)="updateMenuOrder($event)"
          >
        </appform-question-set-navigation>
      </div>
      <div class="container-section">
        <h4 class="section-header">Insurance Application</h4>
        @if ((isAppFormRedirected$ | async) !== true) {
          <div>
            <appform-question-set
              [isContactInfoReady]="isContactInfoReady"
              [isProductInfoReady]="isProductInfoReady"
              [isBusinessTypeReady]="isBusinessTypeReady"
              [isGeneralInfoReady]="isGeneralInfoReady"
              [activeMenuOrder]="activeQuestionSetOrder"
              (questionSetUpdate)="updateFormState($event)"
              [readOnly]="readOnly"
              [formData]="formData"
              [isAppFormReady$]="isAppFormReady$"
              (businessTypeLoad)="updateApplicationState($event)"
              [isAppSyncedWithBP$]="isAppSyncedWithBP$"
              >
            </appform-question-set>
          </div>
        } @else {
          <appform-sdk-question-set
            [formData]="formData"
            [activeQuestionSet]="activeQuestionSet"
            [activeMenuOrder]="activeQuestionSetOrder"
          ></appform-sdk-question-set>
        }
      </div>
    </div>
  }
</ng-container>
